// extracted by mini-css-extract-plugin
export default {"translationLogHeader":"TranslationLog_translationLogHeader__mKN6x"};